import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 *
 * Example:
 *   about: { it: 'chi-siamo', en: 'about-us' }
 *   → /it/chi-siamo, /en/about-us
 */
const multilingual = (it: string, en: string) => ({
  it,
  en,
  fr: en,
  de: en,
  es: en,
  ru: en,
})

export const localizedRoutes = {
  home: multilingual('', ''),
  contacts: multilingual('contattaci', 'contact-us'),
  world: multilingual('il-mondo-nashi-argan', 'the-world-of-nashi-argan'),
  faq: multilingual('faq', 'faq'),
  productsHair: multilingual('prodotti/capelli', 'products/hair'),
  products: multilingual('prodotti', 'products'),
  productsNovita: multilingual('prodotti/novita', 'products/new'),
  productsCorpo: multilingual('prodotti/corpo', 'products/body'),
  productsViso: multilingual('prodotti/viso', 'products/face'),
  productsFragranze: multilingual('prodotti/fragranze', 'products/fragrances'),
  productsUomo: multilingual('prodotti/uomo', 'products/man'),
  privacy: multilingual('privacy-policy', 'privacy-policy'),
  cookiePolicy: multilingual('cookie-policy', 'cookie-policy'),
  nashiLoversClub: multilingual('nashilovers-club', 'nashilovers-club'),
  news: multilingual('news', 'news'),
  diventaPartner: multilingual('diventa-partner', 'become-a-partner'),
  springCollection: multilingual('nashi-spring-collection-2026', 'nashi-spring-collection-2026'),
  storeLocator: multilingual('store-locator', 'store-locator'),
  salon: multilingual('saloni', 'salons'),
  sitemap: multilingual('sitemap', 'sitemap'),
  condizioniWelcomeBox: multilingual('condizioni-generali-di-vendita-welcome-box', 'welcome-box-terms'),
  regaliAziendali: multilingual('regali-aziendali', 'corporate-gifts'),
  regolamento: multilingual('regolamento', 'regulations'),
  eGiftCard: multilingual('e-gift-card', 'e-gift-card'),
  lavoraConNoi: multilingual('lavora-con-noi', 'work-with-us'),
  nashiStore: multilingual('nashi-store', 'nashi-store'),
  nashiPartner: multilingual('nashi-partner', 'nashi-partner'),
  welcomeBox: multilingual('welcome-box', 'welcome-box'),
  login: multilingual('login', 'login'),
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
